import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "video" ]

  connect() {
    this.videoTarget.removeAttribute("autoplay");
  }

  playVideo() {
      this.videoTarget.currentTime = 0.5;
      this.videoTarget.play();
    }

  stopVideo() {
      this.videoTarget.pause();
      this.videoTarget.currentTime = 0.5;
  }

}